export default "__VITE_ASSET__BBD7TuwP__"